import React, { FC, ReactNode } from 'react';
import { ButtonsCont } from './CreateSurveyHeader.styles';
import { HeaderButton } from '../../styles/globals';
import Spinner from '../Spinner/Spinner';

export interface IHeadButton {
  id: string;
  callToAction: () => void;
  name: string;
  icon: ReactNode;
  loading: boolean;
  disabled?: boolean;
  variant?: 'primary' | 'secondary';
}

interface IHeadActionButtons {
  scroll: boolean;
  buttons?: IHeadButton[];
  /** @deprecated use `buttons` with `variant: 'secondary'` */
  light?: IHeadButton;
  /** @deprecated use `buttons` */
  dark?: IHeadButton[];
}

const HeadActionButtons: FC<IHeadActionButtons> = ({ scroll, buttons, light, dark }) => {
  const allButtons: IHeadButton[] = [
    ...(light ? [{ ...light, variant: 'secondary' as const }] : []),
    ...(dark ?? []),
    ...(buttons ?? []),
  ];

  return (
    <ButtonsCont id="ButtonsCont">
      {allButtons.map(button => {
        const variant = button.variant ?? 'primary';
        const showSpinner = button.loading && variant === 'primary';

        return (
          <HeaderButton
            key={button.id}
            type="button"
            onClick={button.callToAction}
            id={button.id}
            data-testid={button.id}
            disabled={button.disabled || showSpinner}
            $variant={variant}
            $compact={scroll}
          >
            {showSpinner ? <Spinner /> : button.icon}
            {button.name}
          </HeaderButton>
        );
      })}
    </ButtonsCont>
  );
};

export default HeadActionButtons;
